/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { EmploymentStatusDto } from './employmentStatusDto.schema';

export const IReadOnlyListOfEmploymentStatusDto = zod.array(zod.lazy(() => EmploymentStatusDto));

export type IReadOnlyListOfEmploymentStatusDto = zod.input<typeof IReadOnlyListOfEmploymentStatusDto>;
export type IReadOnlyListOfEmploymentStatusDtoOutput = zod.output<typeof IReadOnlyListOfEmploymentStatusDto>;
